import { isFeatureEnabled } from '@luna/gatekeeper';

import {
    getContactByIdFromContacts,
    getPrimaryContact,
    isContactEntryAllowed,
} from './ContactService';
import type { PhoneNumber } from './ContactTypes';
import { ContactListFlag } from './ContactDataManagementTypes';
import { getPhoneNumbers } from './PhoneNumbersSourceService';

export function getPhoneNumberById(id: string): PhoneNumber | undefined {
    return getContactByIdFromContacts<PhoneNumber>(id, getPhoneNumbers());
}

export function getPhoneNumberByNumber(number: string | undefined): PhoneNumber | undefined {
    return getPhoneNumbers().find((phoneNumber) => phoneNumber.number === number);
}

function getMobileNumbers(): PhoneNumber[] {
    return getPhoneNumbers().filter((phoneNumber) => phoneNumber.isMobileNumber);
}

export function getPrimaryMobileNumber(): PhoneNumber | undefined {
    return getPrimaryContact(getMobileNumbers());
}

export function isPhoneNumberEntryAllowed(
    mobileNumbersOnly: boolean,
    flags: ContactListFlag[] | undefined,
): boolean {
    if (!isFeatureEnabled((f) => f.contactDataManagement) || !flags) {
        return false;
    }

    if (mobileNumbersOnly) {
        return isContactEntryAllowed(flags, ContactListFlag.MOBILE_PHONE_NOT_ALLOWED);
    }

    return isContactEntryAllowed(flags, ContactListFlag.PHONE_NOT_ALLOWED);
}
